import {translate} from 'views/module';

// A Loom client job has no posting location, so the leading slot of the title falls back to the
// language requirement and then to the client name alone. The list card and the detail header
// both render this title, so the choice lives here rather than once in each.
const jobTitle = (job, clientName, expressions) => {
  if (job?.location?.neighborhood || job?.location?.city) {
    return {
      expression: expressions.location,
      substitute: {
        clientName,
        neighborhood: job.location.neighborhood,
        city: job.location.city,
      },
    };
  }

  // requirements.languages holds the REQUIRED level only; nice-to-have stays off the title.
  const languages = (job?.requirements?.languages || [])
      .map((name) => translate(`career.create.Requirements.LanguageOptions.${name}`))
      .join(', ');

  if (languages) {
    return {expression: expressions.languages, substitute: {clientName, languages}};
  }

  return {expression: expressions.clientOnly, substitute: {clientName}};
};

export default jobTitle;
